import Model, { attr } from '@ember-data/model';

export default class SentinelRoleModel extends Model {
  @attr
  declare name: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'sentinel/role': SentinelRoleModel;
  }
}
